import { z } from "zod";
import { RequestAIDetectionTypeEnumSchema } from "../Enums/RequestAIDetectionTypeEnum";
import { LinkedButtonDtoSchema } from "./LinkedButtonDto";
import { LinkedOdvetvieIdDtoSchema } from "./LinkedOdvetvieIdDto";
import { RequestFileDto, RequestFileDtoSchema } from "./RequestFileDto";

const BaseTaxonomyDtoSchema = z.object({
    id: z.number(),
    name: z.string().nullish(),
    icon: z.string().nullish(),
    aiDetectionType: RequestAIDetectionTypeEnumSchema.nullish(),
    aiCategoryName: z.string().nullish(),
    isSqlValidation: z.boolean(),
    linkedButtons: z.array(LinkedButtonDtoSchema),
    linkedOdvetvie: z.array(LinkedOdvetvieIdDtoSchema),
    isRequestDocument: z.boolean().nullish(),
    allowedExtensions: z.string().nullish(),
    maxFileSize: z.number().nullish(),
    maxNumberOfFiles: z.number().int().nullish(),
});

export type TaxonomyDto = z.infer<typeof BaseTaxonomyDtoSchema> & {
    items?: RequestFileDto[] | null;
}

export const TaxonomyDtoSchema: z.ZodType<TaxonomyDto> = BaseTaxonomyDtoSchema.extend({
    items: z.lazy(() => RequestFileDtoSchema.array()).nullish(),
});
